import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { WidgetBaseComponent } from '../../../widgets/widgetBase';
import { EventBusService } from "../../../../../services/event-bus.service";

/**
 * Text&list section (multiple rows)
 */
@Component({
  selector: 'rd-widget-slide-out',
  templateUrl: './rd-widget-slide-out.component.html',
  styleUrls: ['./rd-widget-slide-out.component.scss']
})
export class RdWidgetSlideOutComponent implements OnInit, OnDestroy {

  /**
   * The widget
   */
  @Input() widget: WidgetBaseComponent;

  /**
   * Subscriptions
   */
  private subscriptions: Subscription[] = [];

  /**
   * Show slideout?
   */
  showSlideOut = null;

  /**
   * Constructor
   * @param cdr ChangeDetectorRef
   */
  constructor(protected eventBus: EventBusService) {}

  /**
   * Initializes the component
   */
  ngOnInit() {
    this.subscriptions.push(this.eventBus.subscribeEvent('widgetToggleSlideOut', (id) => {
      if (id === this.widget.widgetGuid) {
        this.toggleSlideOut(true);
      }
    }));
  }

  /**
   * Destroys the component
   */
  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * Toggles the slide-out
   * @param state
   */
  public toggleSlideOut(state: boolean) {
    this.showSlideOut = state;
  }

  /**
   * Close was clicked
   */
  onCloseClicked() {
    this.toggleSlideOut(false);
  }
}
